// Place application configuration constants here
export const DATA_KEYWORDS = {
  GET_DATA: 'GETDATA',
  POST_DATA: 'POSTDATA',
  POST_SIGN_UP: 'POSTSIGNUP',
  GET_REGISTERED_STATUS: 'GETREGISTEREDSTATUS',
  VALIDATE_PROJECT_TASK: 'VALIDATEPROJECTTASK',
  GET_EXTERNAL_USER_BY_EMAIL: 'GETEXTERNALUSERBYEMAIL',
  GET_EXTERNAL_USERS: 'GETEXTERNALUSERS',
  EXTERNAL_EMAIL_CHECK: 'EXTERNALEMAILCHECK',
  EXTERNAL_PROFILE_IUD: 'EXTERNALPROFILEIUD',
  EXTERNAL_PROFILE_EDITDETAILS: 'EXTERNALPROFILEEDITDETAILS',
  FORMCCIUD: 'FORMCCIUD',
  FORMCC_BY_USERID: 'FORMCCBYUSERID',
  FORMCC_BY_ID: 'FORMCCBYID',
  FORMCC_BY_STATUSID_EXCEPT_DRAFT: 'FORMCCBYSTATUSIDEXCEPTDRAFT',
  FORMCC_BY_STATUSID: 'FORMCCBYSTATUSID',
  GET_FORMCC_FOR_VALIDATE_INVOICE: 'GETFORMCCFORVALIDATEINVOICE',
  GET_FORMCC_FOR_VALIDATE_INVOICE_LIST: 'GETFORMCCFORVALIDATEINVOICELIST',
  GET_FORMCC_FOR_UPLOAD_INVOICE: 'GETFORMCCFORUPLOADINVOICE',
  GET_FORMCC_FOR_UPLOAD_INVOICE_LIST: 'GETFORMCCFORUPLOADINVOICELIST',
  GET_FORMCC_FOR_APPROVAL: 'GETFORMCCFORAPPROVAL',
  APRROVED_OR_REJECT_FORMCC: 'APRROVEDORREJECTFORMCC',
  CHECK_FORMCC_NAME: 'CHECKFORMCCNAME',
  GET_EMPLOYEE_BY_ID: 'GETEMPLOYEEBYID',
  OVERRIDE_USER_DETAIL_IUD: 'OVERRIDEUSERDETAILIUD',
  GET_OVERRIDE_USER_DETAIL: 'GETOVERRIDEUSERDETAIL',
  ALM_DETAILS_IUD: 'ALMDETAILSIUD',
  GET_ALM_DEAITLS_BY_COMBINATION: 'GETALMDEAITLSBYCOMBINATION',
  GET_USERS_GROUP_FOR_ROLE: 'GETUSERSGROUPFORROLE',
  EMAIL_TEMPLATE_IUD: 'EMAILTEMPLATEIUD',
  GET_EMAIL_TEMPLATES: 'GETEMAILTEMPLATES',
  GET_EMAIL_TEMPLATE_BY_ID: 'GETEMAILTEMPLATEBYID',
  GET_ACCDIST_INFO: 'GETACCDISTINFO',
  ACC_DIST_INFO_UPDATE: 'ACCDISTINFOUPDATE',
  ACC_DIST_INFO_GET_BY_NAME: 'ACCDISTINFOGETBYNAME',
  ACC_DIST_INFO_GET_ACTIVE_BY_NAME: 'ACCDISTINFOGETACTIVEBYNAME',
  DELETE_ACCDISTINFO_BY_NAME: 'DELETEACCDISTINFOBYNAME',
  PROJECT_TASK_GET_BY_NAME: 'PROJECTTASKGETBYNAME',
  PROJECT_TASK_GET_ACTIVE_BY_NAME: 'PROJECTTASKGETACTIVEBYNAME',
  PROJECT_TASK_INFO_UPDATE: 'PROJECTTASKINFOUPDATE',
  DELETE_PROJECTTASK_INFO: 'DELETEPROJECTTASKINFO',
  VALIDATE_APPROVED_FORMCC_API: 'VALIDATEAPPROVEDFORMCCAPI',
  UPLOAD_APPROVED_FORMCC_API: 'UPLOADAPPROVEDFORMCCAPI',
  GET_FORMCC_FOR_INVOICE_SENT_TO_OEBS: 'GETFORMCCFORINVOICESENTTOOEBS',
  GET_FORMCC_FOR_CONTROL_REPORT: 'GETFORMCCFORCONTROLREPORT',
  CHARITY_CHECK: 'CHARITYCHECK',
  CHARITY_CHECK_API: 'CHARITYCHECKAPI',
  GET_INVOICE_STATUS_API: 'GETINVOICESTATUSAPI',
  GET_SUBSECTION: 'GETSUBSECTIONAPI',
  GET_PAYMENTCONFIGS: 'GET_PAYMENTCONFIGS',
  IUD_PAYMENTCONFIGS: 'IUD_PAYMENTCONFIGS',
  GET_TAXEXEMPTSUBSECTIONS: 'GET_TAXEXEMPTSUBSECTIONS',
  IUD_TAXEXEMPTSUBSECTIONS: 'IUD_TAXEXEMPTSUBSECTIONS',
  GET_PAYMENTOPTIONS: 'GET_PAYMENTOPTIONS',
  IUD_PAYMENTOPTIONS: 'IUD_PAYMENTOPTIONS',
  GET_PAYMENTPROCESSOR: 'GET_PAYMENTPROCESSOR',
  IUD_PAYMENTPROCESSOR: 'IUD_PAYMENTPROCESSOR',
  GET_FOUNDATIONPAYMENTREQUESTS: 'GET_FOUNDATIONPAYMENTREQUESTS',
  GET_PROCESSEDFOUNDATIONPAYMENTREQUESTS:
    'GET_PROCESSEDFOUNDATIONPAYMENTREQUESTS',
  PROCESS_FOUNDATIONPAYMENTREQUESTS: 'PROCESS_FOUNDATIONPAYMENTREQUESTS',
  UPDATE_FOUNDATIONPAYMENTREQUESTS_CHECKSTATUS:
    'UPDATE_FOUNDATIONPAYMENTREQUESTS_CHECKSTATUS',
  SEND_EMAIL_NOTIFICATION: 'SENDEMAILNOTIFICATION',
  COMPOSE_EMAIL: 'COMPOSEEMAIL',
  GET_FORMCC_FOR_PAYMENT_AS_CREDIT: 'GETFORMCCFORPAYMENTASCREDIT',
  UPDATE_FORMCC_FOR_PAYMENT_AS_CREDIT: 'UPDATEFORMCCFORPAYMENTASCREDIT',
  GET_LGE_EMPLOYEES: 'GETLGEEMPLOYEES',
  NOTIFY_APPROVER_FOR_OUTSTANDING_TASK: 'NOTIFYAPPROVERFOROUTSTANDINGTASK',
  RESET_APPROVER_FOR_OUTSTANDING_TASK: 'RESETAPPROVERFOROUTSTANDINGTASK',
  GET_DOA_AND_NOTIFY_ADMIN: 'GETDOAANDNOTIFYADMIN',
  RESET_DOA_AND_NOTIFY_ADMIN: 'RESETDOAANDNOTIFYADMIN',
  DOWNLOAD_FORMCC_W9FILE: 'DOWNLOADFORMCCW9FILE',
  DOWNLOAD_FORMCC_ADDATTACH_FILE: 'DOWNLOADFORMCCADDATTACHFILE',
  DOWNLOAD_ALL_FORMCC_ADDATTACH_FILE: 'DOWNLOADALLFORMCCADDATTACHFILE',
  GET_EIN_ORGINFO_DETAIL: 'GETEINORGINFODETAIL',
  EIN_ORGINFO_DETAIL_IUD: 'EINORGINFODETAILIUD',

  GET_EMPLOYEE_HIERARCHY_TEST: 'GETEMPLOYEEHIERARCHYTEST',

  //TESTMVC_CALL: 'AUTOREJECTFORMCCONHEIRARCHYCHANGE',
  TEST: 'FORMFOBYID',
  //TESTMVC_CALL : 'NOTIFYAPPROVERFOROUTSTANDINGTASK',
  // TESTMVC_CALL : 'GETEMPLOYEEHIERARCHYTEST',
  TESTMVC_CALL: 'GETACCDISTINFO',
  // FORM CI
  FORMCI_BY_ID: 'FORMCIBYID',
  FORMCI_IUD: 'FORMCI_IUD',
  FORMCI_BY_STATUSID_EXCEPT_DRAFT: 'FORMCIBYSTATUSIDEXCEPTDRAFT',
  FORMEXT_BY_USERID: 'FORMEXT_BYUSERID',
  GET_FORMCI_PENDING_OR_APPROVED: 'GETFORMCIPENDINGORAPPROVED',
  APRROVE_REJECT_WITHDRAW_FORMCI: 'APRROVEREJECTWITHDRAWFORMCI',
  GET_FORMCI_FOR_VALIDATE_INVOICE: 'GETFORMCIFORVALIDATEINVOICE',
  GET_FORMCI_FOR_UPLOAD_INVOICE: 'GETFORMCIFORUPLOADINVOICE',
  GET_FORMCI_FOR_INVOICE_SENT_TO_OEBS: 'GETFORMCIFORINVOICESENTTOOEBS',
  GET_FORMCI_FOR_CONTROL_REPORT: 'GETFORMCIFORCONTROLREPORT',
  GET_FORMCI_FOR_PAYMENT_AS_CREDIT: 'GETFORMCIFORPAYMENTASCREDIT',
  DOWNLOAD_FORMCI_ATTACHMENT: 'DOWNLOAD_FORMCI_ATTACHMENT',
  DOWNLOADALL_FORMCI_ADDATTACHMENT: 'DOWNLOADALL_FORMCI_ADDATTACHMENT',
  DELETE_FORMCIATTACHMENT: 'DELETE_FORMCIATTACHMENT',
  DELETEALL_FORMCI_ADDATTACHMENT: 'DELETEALL_FORMCI_ADDATTACHMENT',
  DELETE_FROMFILESERVICES: 'DELETE_FROMFILESERVICES',
  DOWNLOAD_FROMFILESERVICES: 'DOWNLOAD_FROMFILESERVICES',

  // formFO
  FORMFO_IUD: 'FORMFO_IUD',
  FORMFO_BY_ID: 'FORMFOBYID',
  FORMFO_BY_STATUSID_EXCEPT_DRAFT: 'FORMFOBYSTATUSIDEXCEPTDRAFT',
  GET_FORMFO_PENDING_OR_APPROVED: 'GETFORMFOPENDINGORAPPROVED',
  APRROVED_OR_REJECT_FORMFO: 'APRROVEDORREJECTFORMFO',
  APRROVE_REJECT_WITHDRAW_FORMFO: 'APRROVEREJECTWITHDRAWFORMFO',
  DOWNLOAD_FORMFO_ATTACHMENT: 'DOWNLOAD_FORMFO_ATTACHMENT',
  DOWNLOADALL_FORMFO_ADDATTACHMENT: 'DOWNLOADALL_FORMFO_ADDATTACHMENT',
  DELETE_FORMFOATTACHMENT: 'DELETE_FORMFOATTACHMENT',
  DELETEALL_FORMFO_ADDATTACHMENT: 'DELETEALL_FORMFO_ADDATTACHMENT',

  // formPP
  FORMPP_IUD: 'FORMPP_IUD',
  FORMPP_BY_ID: 'FORMPPBYID',
  FORMPP_BY_STATUSID_EXCEPT_DRAFT: 'FORMPPBYSTATUSIDEXCEPTDRAFT',
  DOWNLOAD_FORMPP_ATTACHMENT: 'DOWNLOAD_FORMPP_ATTACHMENT',
  DOWNLOADALL_FORMPP_ADDATTACHMENT: 'DOWNLOADALL_FORMPP_ADDATTACHMENT',
  DELETE_FORMPPATTACHMENT: 'DELETE_FORMPPATTACHMENT',
  DELETEALL_FORMPP_ADDATTACHMENT: 'DELETEALL_FORMPP_ADDATTACHMENT',
  GET_FORMPP_PENDING_OR_APPROVED: 'GETFORMPPPENDINGORAPPROVED',
  APRROVE_REJECT_WITHDRAW_FORMPP: 'APRROVEREJECTWITHDRAWFORMPP',
  GET_FORMPP_FOR_VALIDATE_INVOICE: 'GETFORMPPFORVALIDATEINVOICE',
  GET_FORMPP_FOR_UPLOAD_INVOICE: 'GETFORMPPFORUPLOADINVOICE',
  GET_FORMPP_FOR_INVOICE_SENT_TO_OEBS: 'GETFORMPPFORINVOICESENTTOOEBS',
  GET_FORMPP_FOR_CONTROL_REPORT: 'GETFORMPPFORCONTROLREPORT',

  // formMG
  FORMMG_IUD: 'FORMMG_IUD',
  FORMMG_BY_ID: 'FORMMGBYID',
  FORMMG_BY_STATUSID_EXCEPT_DRAFT: 'FORMMGBYSTATUSIDEXCEPTDRAFT',
  APRROVED_OR_REJECT_FORMMG: 'APRROVEDORREJECTFORMCMG',

  // formCG
  FORMCG_IUD: 'FORMCG_IUD',
  FORMCG_BY_ID: 'FORMCGBYID',
  FORMCGBYSTATUSIDEXCEPTDRAFT: 'FORMCGBYSTATUSIDEXCEPTDRAFT',
  FORMCG_BY_STATUSID_EXCEPT_DRAFT: 'FORMCGBYSTATUSIDEXCEPTDRAFT',
  APPRROVE_REJECT_WITHDRAW_FORMCG: 'APPRROVEDORREJECTFORMCG',
  GET_FORMCG_PENDING_OR_APPROVED: 'GETFORMCGPENDINGORAPPROVED',
  GET_FORMCG_FOR_VALIDATE_INVOICE: 'GETFORMCGFORVALIDATEINVOICE',
  GET_FORMCG_FOR_UPLOAD_INVOICE: 'GETFORMCGFORUPLOADINVOICE',
  GET_FORMCG_FOR_INVOICE_SENT_TO_OEBS: 'GETFORMCGFORINVOICESENTTOOEBS',
  GET_FORMCG_FOR_CONTROL_REPORT: 'GETFORMCGFORCONTROLREPORT',
  GET_FORMCG_FOR_PAYMENT_AS_CREDIT: 'GETFORMCGFORPAYMENTASCREDIT',

  ACCDISTEXTIUD: 'ACCDISTEXTIUD',
  GETACTIVEFORMS: 'GETACTIVEFORMS',
  FORMCONFIGSIUD: 'FORMCONFIGSIUD',
  GETFORMCONFIGS: 'GETFORMCONFIGS',
  EXCEPTIONEINCHECK: 'EXCEPTION_EIN_CHECK',

  GETOPENREQUESTS: 'GETOPENREQUESTS',
  GETCLOSEDREQUESTS: 'GETCLOSEDREQUESTS',
  CLOSREQUESTS: 'CLOSREQUESTS',

  VALIDATE_APPROVED_FORMEXT_API: 'VALIDATEAPPROVEDFORMEXTAPI',
  UPLOAD_APPROVED_FORMEXT_API: 'UPLOADAPPROVEDFORMEXTAPI',
  GETTOAWARDDECLINEADD: 'GETTOAWARDDECLINEADD',
  COMPOSE_AWARDDECLINE_EMAIL: 'COMPOSE_AWARDDECLINE_EMAIL',
  GET_FORMPP_FOR_PAYMENT_AS_CREDIT: 'GETFORMPPFORPAYMENTASCREDIT',
  UPDATE_FORMEXT_FOR_PAYMENT_AS_CREDIT: 'UPDATEFORMEXTFORPAYMENTASCREDIT',
};

export const SHARE_ARRAYS = {
  states: [
    'AK',
    'AL',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
  taxExemptList: [
    '01',
    '02',
    '03',
    '04',
    '05',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '',
  ],
  serviceAreas: ['LG&E Service Area', 'KU Service Area', 'ODP Service Area'],
};

export const ExternalStatus = {
  Submitted: 1,
  Draft: 2,
  Submitted_Approved: 3,
  Submitted_Rejected: 4,
  Withdrawn_Withdrawn: 5,
  Closed: 6,
  Submitted_PendingCRCAApproval: 7,
  Submitted_PendingCCCReview: 8,
  Submitted_PendingFoundationBODReview: 9,
  Closed_Rejected: 10,
  Closed_Approved: 11,
  Submitted_SentToOracle: 12,
  Closed_SentToOracle: 13,
  Closed_Negotiable: 14,
  Closed_Reconciled: 15,
  Closed_Voided: 16,
  Submitted_PaidCredit: 17,
  Closed_PaidCredit: 18,
  Submitted_Negotiable: 20,
  Submitted_Reconciled: 21,
  Submitted_Voided: 22,
  Submitted_PendingCITReview: 23,
  ReassignToCI: 24,
  Submitted_SentToFoundationTrustee: 25,
  Closed_SentToFoundationTrustee: 26,
  Expired_Expired: 27,
};
export const HomeConstants = [
  'UserInt',
  'UserExt',
  'FormCCExceptDraft',
  'FormCCPendingApproval',
  'FormCCApproved',
  'FormMGExceptDraft',
  'FormCGExceptDraft',
  'FormCGPendingApproval',
  'FormCGApproved',
  'FormESExceptDraft',
  'FormESPendingApproval',
  'FormESApproved',
  'FormPPExceptDraft',
  'FormPPPendingApproval',
  'FormPPApproved',
];
export const SESSION_KEY = 'CCMS.session';
